/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtInitializeReward = {
  pool: Address;
  rewardMint: Address;
  funder: Address;
  creator: Address;
  rewardIndex: number;
  rewardDuration: bigint;
};

export type EvtInitializeRewardArgs = {
  pool: Address;
  rewardMint: Address;
  funder: Address;
  creator: Address;
  rewardIndex: number;
  rewardDuration: number | bigint;
};

export function getEvtInitializeRewardEncoder(): FixedSizeEncoder<EvtInitializeRewardArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["rewardMint", getAddressEncoder()],
    ["funder", getAddressEncoder()],
    ["creator", getAddressEncoder()],
    ["rewardIndex", getU8Encoder()],
    ["rewardDuration", getU64Encoder()],
  ]);
}

export function getEvtInitializeRewardDecoder(): FixedSizeDecoder<EvtInitializeReward> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["rewardMint", getAddressDecoder()],
    ["funder", getAddressDecoder()],
    ["creator", getAddressDecoder()],
    ["rewardIndex", getU8Decoder()],
    ["rewardDuration", getU64Decoder()],
  ]);
}

export function getEvtInitializeRewardCodec(): FixedSizeCodec<
  EvtInitializeRewardArgs,
  EvtInitializeReward
> {
  return combineCodec(
    getEvtInitializeRewardEncoder(),
    getEvtInitializeRewardDecoder(),
  );
}
